import React from 'react';
import { DogList } from '@/components/DogList';
import { Button } from "@/components/ui/button";
import { LockKeyhole, UnlockKeyhole } from 'lucide-react';

export function DogManagementSection({
  currentDogList,
  selectedDayKey,
  completedDogs,
  urgentDogs,
  daysList,
  onDogClick,
  onUrgentClick,
  onDelete,
  onEdit,
  onReorder,
  currentDate,
  getInitialDayData,
  requireConfirmation,
  onApplyCanceledDaysBatch,
  isReadOnly,
  reorderUnlocked,
  setReorderUnlocked,
  isSelectedProfileInformational
}) {
  return (
    <div className="flex-1">
      <div className="overflow-y-auto -mx-2 sm:-mx-4 px-2 sm:px-4 scroll-smooth pb-8 relative -top-7">
        <div style={{ marginTop: '25px' }}>
           <DogList
             dogs={currentDogList}
             selectedDayKey={selectedDayKey}
             completedDogs={completedDogs}
             urgentDogs={urgentDogs}
             daysList={daysList}
             onDogClick={onDogClick}
             onUrgentClick={onUrgentClick}
             onDelete={onDelete}
             onEdit={onEdit}
             onReorder={onReorder}
             currentDate={currentDate}
             getInitialDayData={getInitialDayData}
             requireConfirmation={requireConfirmation}
             onApplyCanceledDaysBatch={onApplyCanceledDaysBatch}
             isReadOnly={isReadOnly}
             reorderUnlocked={reorderUnlocked}
             setReorderUnlocked={setReorderUnlocked}
             isSelectedProfileInformational={isSelectedProfileInformational}
           />
         </div>
      </div>
    </div>
  );
}
